import { getFullUrl } from 'hubspot-url-utils';
function getIsLocal() {
  try {
    return localStorage.getItem('UPGRADE_IFRAME_ENV') === 'local';
  } catch (e) {
    return false;
  }
}
export const getIframeModalHost = () => getFullUrl(getIsLocal() ? 'local' : 'app', {});